import Component from "@base/js/component";
import Drawer from "@components/drawer/drawer";
import $ from "jquery";

export default class PerformanceDataList extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".performance-data-list";

  // Defines children that needs to be queried as part of this component
  static children = {
    contentItemContainer: ".performance-data-list__contents",
    expandedContainer: ".performance-data-list__item-expanded-content",
    expandButton: ".performance-data-list__item-expand",
    tooltipIcons: [".performance-data-list .tooltip-trigger"],
    tooltipIconsOnHover: [
      ".performance-data-list .tooltip-trigger.show-tooltip-on-hover",
    ],
    searchInput: ".performance-data-list__search-field-input",
    selectionItems: [".performance-data-list__selection-item"],
    selectionHeading: ".performance-data-list__selection-heading",
    selectionHeadingText: ".performance-data-list__selection-heading-text",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    drawers: [Drawer],
  };

  isTransitioning = false;

  isSelectionTransitioning = false;

  // Defines event handlers to attach to children
  eventHandlers = {
    expandedContainer: {
      transitionstart: this.onExpandedRowTransitionStart,
      transitionend: this.onExpandedRowTransitionEnd,
    },
    selectionHeading: {
      click: this.onSelectionHeaderClick,
    },
    tooltipIcons: {
      click: this.onTooltipClick,
      transitionstart: this.onTooltipTransitionStart,
      transitionend: this.onTooltipTransitionEnd,
    },
    tooltipIconsOnHover: {
      mouseenter: this.onTooltipHoverEnter,
      mouseleave: this.onTooltipHoverLeave,
    },
    selectionItems: {
      click: this.onSelectionClick,
    },
    searchInput: {
      keyup: this.onSearchInputChange,
    },
  };

  afterInit() {
    const { expandedContainer, expandButton } = this.children;
    const self = this;
    if (expandButton && expandedContainer) {
      // to make sure that dom is rendered to get exact render height
      setTimeout(() => {
        expandButton.addEventListener("click", (ev) => {
          ev.preventDefault();
          if (expandedContainer.classList.contains("content-expanded")) {
            self.hideRow(expandedContainer);
            $(expandButton).find("span.inner-text").text("Expand");
          } else {
            self.expandRow(expandedContainer);
            $(expandButton).find("span.inner-text").text("Collapse");
            const firstLinkOnExpand = expandedContainer.querySelector(
              ".performance-data-list__item-cta-link"
            );
            $(firstLinkOnExpand).trigger("focus");
          }
        });
        self.hideRow(expandedContainer);
      }, 250);

      $(
        ".performance-data-list .performance-data-list__item-source,.performance-data-list .performance-data-list__item-header-tooltip-icon"
      ).on("keydown", (e) => {
        if (/^(13|32)$/.test(e.which)) {
          e.preventDefault();
          self.toggleTooltip(e, "click");
        }
      });
    }

    // Add event listener to check if the user clicks outside the container
    $(document).on("click", (event) => {
      if (
        !$(event.target).closest(
          ".performance-data-list__item-source-container"
        ).length
      ) {
        if (
          $(".performance-data-list__item-source-container .show-tooltip")
            .length > 0
        )
          $(
            ".performance-data-list__item-source-container .show-tooltip"
          ).removeClass("show-tooltip");
      }
      if (
        !$(event.target).closest(".performance-data-list__item-header-column")
          .length
      ) {
        if (
          $(".performance-data-list__item-header-column .show-tooltip").length >
          0
        )
          $(
            ".performance-data-list__item-header-column .show-tooltip"
          ).removeClass("show-tooltip");
      }
      if (
        !$(event.target).closest(".performance-data-list__selection-drawer")
          .length
      ) {
        if (
          $(".performance-data-list__selection-drawer .drawer--expanded")
            .length > 0
        )
          this.children.selectionHeading.click();
      }
    });

    window.onbeforeunload = () => {
      const searchValue = this.children.searchInput.value;
      const filterValue = $(this.children.selectionHeading).attr(
        "data-selected-value"
      );
      if (!filterValue || filterValue === "All") {
        if (searchValue) {
          window.history.replaceState(
            { searchValue, filterValue },
            "",
            `?search=${searchValue}`
          );
        }
      } else {
        window.history.replaceState(
          { searchValue, filterValue },
          "",
          `?search=${searchValue}&filter=${filterValue}`
        );
      }
    };

    // check if url has query
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if (params) {
      const searchValue = params.search;
      if (searchValue) {
        this.children.searchInput.value = searchValue;
        this.updateSearchInput(searchValue);
      }
      const filterValue = params.filter;
      if (filterValue) {
        const filterValues = [
          ...$(".performance-data-list__selection-selections > [data-value]"),
        ].map((d) => $(d).attr("data-value"));
        if (filterValues.includes(filterValue)) {
          this.updateSelectionValue(filterValue, filterValue);
        }
      }
    }
  }

  onSelectionClick(e) {
    const { selectionHeading } = this.children;
    const item = e.target;
    const value = item.getAttribute("data-value");
    const name = item.innerText;
    if (name && value) {
      selectionHeading.click();
      this.updateSelectionValue(name, value);
    }
  }

  onSelectionHeaderClick(e) {
    this.toggleTooltip(e, "hideAll");
  }

  updateSelectionValue(name, value) {
    const length = 50;
    let myTruncatedName = name.substring(0, length);
    if (name.length > length) {
      myTruncatedName += "...";
    }

    const { selectionHeading, selectionHeadingText } = this.children;
    selectionHeadingText.innerHTML = myTruncatedName;
    selectionHeading.setAttribute("data-selected-value", value);
    if (value === "All") {
      this.filterChange(true, "");
    } else {
      this.filterChange(false, value);
    }
  }

  filterChange(showAll, value = "") {
    const inputValue = $(".performance-data-list__search-field-input").val();
    this.updateSearchInput("");
    if (showAll) {
      $(".performance-data-list__group-item").removeClass("filtered-out");
      $(".performance-data-list__group-item").removeClass("result-hidden");
      $(this.children.contentItemContainer).removeClass("has-filter-active");
    } else {
      $(".performance-data-list__group-item").removeClass("result-hidden");
      $(".performance-data-list__group-item").removeClass("filtered-out");
      $(this.children.contentItemContainer).addClass("has-filter-active");
      $(".performance-data-list__group-item").each((i, el) => {
        if (
          $(el)
            .find(".performance-data-list__group-header:first")
            .text()
            .trim() !== value.trim()
        ) {
          $(el).addClass("result-hidden");
          $(el).addClass("filtered-out");
        }
      });
    }
    this.updateSearchInput(inputValue);
  }

  onExpandedRowTransitionStart(e) {
    if (e.target === e.currentTarget) {
      this.isTransitioning = true;
    }
  }

  onTooltipTransitionStart(e) {
    if (e.target === e.currentTarget) {
      $(e.target).addClass("is-transitioning");
    }
  }

  onTooltipTransitionEnd(e) {
    if (e.target === e.currentTarget) {
      $(e.target).removeClass("is-transitioning");
    }
  }

  onExpandedRowTransitionEnd(e) {
    if (e.target === e.currentTarget) {
      if (
        !this.children.expandedContainer.classList.contains("content-expanded")
      ) {
        this.children.expandedContainer.style.display = "none";
      }
    }
  }

  expandRow(expandedContainer) {
    expandedContainer.style.display = "block";
    expandedContainer.style.height = `unset`;
    const { height } = expandedContainer.getBoundingClientRect();
    expandedContainer.style.height = `${0}px`;
    setTimeout(() => {
      expandedContainer.style.height = `${height}px`;
      expandedContainer.classList.add("content-expanded");
    }, 100);
  }

  hideRow(expandedContainer) {
    const { height } = expandedContainer.getBoundingClientRect();
    expandedContainer.style.height = `${height}px`;
    setTimeout(() => {
      expandedContainer.style.height = `${0}px`;
      expandedContainer.classList.remove("content-expanded");
    }, 100);
  }

  updateRowHeightOnResize() {
    const { expandedContainer } = this.children;

    const totalExpandedHeight =
      expandedContainer.getBoundingClientRect().height;
    if (totalExpandedHeight > 0) {
      expandedContainer.setAttribute(
        "data-expanded-height",
        `${totalExpandedHeight}`
      );
      this.hideRow();
    }
  }

  onTooltipClick(ev) {
    this.toggleTooltip(ev, "click");
  }

  onTooltipHoverEnter(ev) {
    this.toggleTooltip(ev, "hover");
  }

  onTooltipHoverLeave(ev) {
    this.toggleTooltip(ev, "leave");
  }

  toggleTooltip(ev, eventType) {
    const targetEl = ev.target;
    if (eventType === "hideAll") {
      $(".show-tooltip").removeClass("show-tooltip");
      return;
    }

    if (eventType === "hover" && $(targetEl).hasClass("show-tooltip")) {
      return;
    }

    let sibling = targetEl.querySelector(".tooltip-trigger-content");
    if (!sibling && targetEl.nextElementSibling) {
      sibling = targetEl.nextElementSibling;
    }
    if (targetEl === ev.currentTarget && sibling) {
      if (eventType === "click") {
        $(".show-tooltip").each((i, el) => {
          if (el !== targetEl) {
            $(el).removeClass("show-tooltip");
          }
        });
        targetEl.classList.toggle("show-tooltip");
      } else if (eventType === "hover") {
        $(".show-tooltip").removeClass("show-tooltip");
        targetEl.classList.add("show-tooltip");
      } else if (eventType === "leave") {
        $(".show-tooltip").removeClass("show-tooltip");
      }
      if (targetEl.classList.contains("show-tooltip")) {
        sibling.style.display = "block";
        sibling.style.opacity = "0";
        $(sibling).attr("role", "");
        setTimeout(() => {
          sibling.style.opacity = "1";
          sibling.style.display = "";
          $(sibling).attr("role", "alert");
        }, 100);
      }
    }
  }

  updateSearchInput(searchInputValue) {
    if (searchInputValue.length > 0) {
      $(this.children.contentItemContainer).addClass("has-search-input-active");
      $(".has-search-input-active .performance-data-list__item").removeClass(
        "result-hidden"
      );
      $(
        ".has-search-input-active .performance-data-list__group-item"
      ).removeClass("result-hidden");
      $(this.children.contentItemContainer).removeClass("no-results");
      $(".has-search-input-active .performance-data-list__item").each(
        (i, item) => {
          const itemLink = $(item)
            .find(".performance-data-list__item-cta-link")
            .first();
          if (
            $(itemLink)
              .text()
              .toLowerCase()
              .includes(searchInputValue.toLowerCase())
          ) {
            const defaultText = $(itemLink).text().trim();
            const regex = new RegExp(searchInputValue, "gi");
            if (defaultText.search(regex) !== -1) {
              $(itemLink).html(defaultText.replace(regex, "<b>$&</b>"));
            }
          } else {
            $(item).addClass("result-hidden");
          }
        }
      );

      // hide section that is empty
      $(".has-search-input-active .performance-data-list__group-item").each(
        (i, item) => {
          const itemLink = $(item).find(
            ".performance-data-list__item:not(.result-hidden)"
          );
          if (itemLink.length === 0) {
            $(item).addClass("result-hidden");
          }
        }
      );

      // check if no results found

      const groupItems = $(this.children.contentItemContainer).find(
        `.performance-data-list__group-item:not(.result-hidden):not(.filtered-out)`
      );
      if (groupItems.length === 0) {
        $(this.children.contentItemContainer).addClass("no-results");
        $(this.children.contentItemContainer)
          .find(".no-results-search-input")
          .html(searchInputValue);
        $(".performance-data-list__group-item").addClass("result-hidden");
      }
    } else {
      $(this.children.contentItemContainer).removeClass("no-results");
      $(".has-search-input-active .performance-data-list__item b")
        .contents()
        .unwrap();
      $(".performance-data-list__item").removeClass("result-hidden");
      $(".performance-data-list__group-item").removeClass("result-hidden");
      $(this.children.contentItemContainer).removeClass(
        "has-search-input-active"
      );
    }
  }

  onSearchInputChange(ev) {
    const searchInputValue = $(ev.target).val().trim();
    this.updateSearchInput(searchInputValue);
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
PerformanceDataList.init();
